module.exports = __webpack_public_path__ + "b5a16a705cb72047d06c4867505b428e.glb";